module.exports = __webpack_public_path__ + "5b6a9ee3aae38c087b124af17d615219.png";